module.exports = __webpack_public_path__ + "img/gb894_2.prt.b194ae74.jpg";